import * as XLSX from "xlsx";

const SHEET_NAME = "Outward";
const FILENAME = "outward_upload_format.xlsx";

const TEMPLATE_HEADERS = [
 "Company",
 "Secondary Customer",
 "Customer SKU Code",
 // ❌ LEGACY bulk upload column label (replaced by Customer SKU Code)
 // "Product SKU",
 // ❌ DISABLED: Product Description removed from bulk upload format (description resolved from Product Master on create)
 // "Product Description",
 "Dispatch Quantity",
 "Posting Date",
 "Vehicle Number",
 // ❌ OLD
 // "Location",
 "Vehicle Temperature",
 "Reporting Date",
 "Reporting Time",
 "Dock Number",
 "Dock In Time",
 "Dock Out Time",
 "Product Temperature",
 "Method",
 "Batch Number",
 "Batch Quantity",
];

const INSTRUCTIONS_ROW = [
 "Company name(s), comma separated for multiple (case-insensitive)",
 "Optional. Secondary customer name(s), comma separated (must be mapped to each company)",
 "Customer SKU Code(s), comma separated for multiple products",
 // ❌ LEGACY: "Product SKU(s), comma separated for multiple products",
 // ❌ DISABLED: Product Description no longer accepted in bulk upload
 // "Product description(s), comma separated - keep same order as SKU list (optional)",
 "number > 0",
 "optional (YYYY-MM-DD; defaults to today if blank)",
 "optional (grouping happens by Company+Vehicle)",
 "optional number (°C)",
 "optional (YYYY-MM-DD)",
 "optional (HH:mm)",
 "optional (e.g. D-01)",
 "optional (e.g. 2025-02-01 10:00)",
 "optional (e.g. 2025-02-01 11:00)",
 "optional number (°C)",
 "FEFO or MANUAL",
 "MANUAL only: Batch number(s), comma separated for multiple batches",
 "MANUAL only: Batch quantity(s), comma separated (sum must equal dispatch qty)",
];

const SAMPLE_ROW_FEFO = [
 "Company A",
 "Sub A1, Sub A2",
 "SKU-001",
 50,
 "2025-02-01",
 "VEH-001",
 2,
 "2025-02-01",
 "10:30",
 "D-01",
 "2025-02-01 10:00",
 "2025-02-01 11:00",
 4,
 "FEFO",
 "",
 "",
];

const SAMPLE_ROW_FEFO_2 = [
 "Company A, Company B",
 "",
 "SKU-002, SKU-003",
 30,
 "2025-02-01",
 "VEH-001",
 2,
 "",
 "",
 "D-01",
 "2025-02-01 10:00",
 "2025-02-01 11:00",
 4,
 "FEFO",
 "",
 "",
];

const SAMPLE_ROW_MANUAL = [
 "Company C",
 "Sub C1",
 "SKU-003",
 30,
 "2025-02-01",
 "VEH-002",
 2,
 "2025-02-01",
 "09:15",
 "D-01",
 "2025-02-01 10:00",
 "2025-02-01 11:00",
 4,
 "MANUAL",
 "BATCH-2025-001",
 30,
];

const SAMPLE_ROW_MANUAL_MULTIPLE = [
 "Company D",
 "Sub D1, Sub D2",
 "SKU-004",
 100,
 "2025-02-01",
 "VEH-003",
 2,
 "",
 "",
 "D-01",
 "2025-02-01 10:00",
 "2025-02-01 11:00",
 4,
 "MANUAL",
 "BATCH-2025-001, BATCH-2025-002",
 "50, 50",
];

export function downloadOutwardUploadTemplate() {
  const wsData = [
    TEMPLATE_HEADERS,
    INSTRUCTIONS_ROW,
    SAMPLE_ROW_FEFO,
    SAMPLE_ROW_FEFO_2,
    SAMPLE_ROW_MANUAL,
    SAMPLE_ROW_MANUAL_MULTIPLE,
  ];

  const ws = XLSX.utils.aoa_to_sheet(wsData);

  ws["!cols"] = [
   { wch: 30 }, // Company
   { wch: 30 }, // Secondary Customer
   { wch: 35 }, // Customer SKU Code
   // ❌ LEGACY: { wch: 35 }, // Product SKU
   // ❌ DISABLED: { wch: 35 }, // Product Description
   { wch: 18 }, // Dispatch Quantity
   { wch: 16 }, // Posting Date
   { wch: 16 }, // Vehicle Number
   { wch: 18 }, // Vehicle Temperature
   { wch: 16 }, // Reporting Date
   { wch: 16 }, // Reporting Time
   { wch: 14 }, // Dock Number
   { wch: 22 }, // Dock In Time
   { wch: 22 }, // Dock Out Time
   { wch: 20 }, // Product Temperature
   { wch: 20 }, // Method
   { wch: 35 }, // Batch Number
   { wch: 25 }, // Batch Quantity
 ];

  const startRow = 3;
  const endRow = 5000;

  // Method column is N (index 13) after Posting Date column added
  ws["!dataValidation"] = [
    {
      type: "list",
      allowBlank: 0,
      sqref: `N${startRow}:N${endRow}`,
      formulas: ['"FEFO,MANUAL"'],
    },
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, SHEET_NAME);

  const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([wbout], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = FILENAME;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
